import { formatNumber, pluralize } from '@/utils/number';

export const formatEntryCount = (count: number): string =>
  `${formatNumber(count)} ${pluralize(count, 'entry', 'entries')}`;
